import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment-hijri';
moment.locale('ar');

@Pipe({
  name: 'hijriDate',
})
export class HijriDatePipe implements PipeTransform {
  transform(
    value: any,
    format: string = 'iDD-iMM-iYYYY',
    lang: 'ar' | 'en' = 'en'
  ): string {
    if (!value) return '';

    const hijriMonthsArabic = [
      'محرّم',
      'صفر',
      'ربيع أول',
      'ربيع آخر',
      'جماد أول',
      'جماد آخر',
      'رجب',
      'شعبان',
      'رمضان',
      'شوّال',
      'ذو القعدة',
      'ذو الحجة',
    ];

    const hijriMonthsLatin = [
      'Muharram', // 1st month
      'Safar', // 2nd month
      "Rabi'-Awl", // 3rd month
      "Rabi'-Thn", // 4th month
      'Jumada-Awl', // 5th month
      'Jumada-Thn', // 6th month
      'Rajab', // 7th month
      "Sha'ban", // 8th month
      'Ramadan', // 9th month
      'Shawwal', // 10th month
      "Dhu Qi'dah", // 11th month
      'Dhu Hijjah', // 12th month
    ];

    let date = moment(value).format(format);

    let [day, month, year] = date.split('-'); // Assuming the format is 'iDD-iMMMM-iYYYY'

    const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    const latinNumerals = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    month = month.replace(/[٠-٩]/g, (digit) => {
      const index = arabicNumerals.indexOf(digit);
      return latinNumerals[index];
    });

    const monthIndex = parseInt(month, 10) - 1; // Convert month to 0-based index

    if (monthIndex >= 0 && monthIndex <= 11) {
      month =
        lang === 'ar'
          ? hijriMonthsArabic[monthIndex]
          : hijriMonthsLatin[monthIndex];
    }

    // return day + '-' + month + '-' + year;
    return day + ' ' + month + ' ' + year + (lang === 'ar' ? 'هـ' : 'H');
  }
}
